import { render, staticRenderFns } from "./FTRB.vue?vue&type=template&id=fde67376&scoped=true"
import script from "./FTRB.vue?vue&type=script&lang=js"
export * from "./FTRB.vue?vue&type=script&lang=js"
import style0 from "./FTRB.vue?vue&type=style&index=0&id=fde67376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde67376",
  null
  
)

export default component.exports